import { createApiInstance } from './config'

// 使用统一的API实例
const api = createApiInstance()

// 获取保姆统计列表（保姆会话 + 脚本窗口状态）
export const getNannyDevices = (params = {}) => {
  return api.get('/nanny/devices', { params })
}

// 保姆心跳
export const nannyHeartbeat = (roleId, deviceId) => {
  return api.post('/nanny/heartbeat', { roleId, deviceId })
}

// 下发停止脚本命令（保姆/后台）
export const stopNannyScript = (roleId) => {
  return api.post('/nanny/stop-script', { roleId })
}

// 脚本端轮询获取停止标志（如果你想在脚本里复用这个封装）
export const getStopFlag = (roleId) => {
  return api.get(`/nanny/stop-flag/${roleId}`)
}

